// import React from "react";
import { useState, useEffect, useContext, useCallback } from "react";
// import Styles from "./ListQus.module.css";
import { useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "../constants/apiConfig";
import QuizCard from "./QuizCard";
import PerformanceSummary from "./PerformanceSummary";
import LoginContext from "./LoginContext";
// 1. Define types for the input and output structures
interface OriginalAnswer {
    qustionId: string;
    userAnswer: 'A' | 'B' | 'C' | 'D';
}


const GenQus = () => {
    const [searchParams] = useSearchParams();
    const test_id = searchParams.get("test_id");
    const [qus, setQus]: any[] = useState([]);
    const [submited, setSubmited] = useState(false);
    const [userAnswers, setUserAnswers]: any[] = useState([]);
    const [correctCount, setCorrectCount] = useState(0);
    const [currentIndex, setcurrentIndex] = useState(1);
    const [progressValue, setProgressValue] = useState(0);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { userId }: any = useContext(LoginContext);

    const fetchQuestion = useCallback(() => {
        // Logic to fetch questions for the current page based on currentIndex
        // For example, you might want to fetch questions for the current page from the server here
        // After fetching, update the qus state with the new questions
        const endpoint = test_id
            ? `${API_BASE_URL}/admin/assignedTest?user_id=${userId}&test_id=${test_id}`
            : `${API_BASE_URL}/admin/genQus`;

        fetch(endpoint, {
            credentials: "include",
        })
            .then((response) => response.json())
            .then((data: any) => {
                setQus(data);
                setIsLoading(false);
            });
    }, [test_id, userId]);


    useEffect(() => {
        fetchQuestion();
    }, [fetchQuestion]);

    useEffect(() => {
        const updateProgressValue = () => {
            const totalQuestions = qus.length;
            const answeredQuestions = Object.entries(userAnswers).length;
            const progress = totalQuestions > 0 ? Math.round((answeredQuestions / totalQuestions) * 100) : 0;

            if (progress === 100) {
                setEnableSubmit(true);
            }
            setProgressValue(progress);
        }
        updateProgressValue();
    }, [userAnswers, qus.length]);


    // const userSelected = (questionId: string, option: string) => {
    //     const flatAnswers: any = Object.values(userAnswers).reduce((acc: any, current: any) => {
    //         acc[current.qustionId] = current.userAnswer;
    //         return acc;
    //     }, {});
    //     if (flatAnswers[questionId] === option) {
    //         return true;
    //     }
    //     return false;
    // };

    const retestHandler = () => {
        fetchQuestion();
        setSubmited(false);
        setUserAnswers([]);
        setCorrectCount(0);
        setProgressValue(0);
        setcurrentIndex(1);
        setEnableSubmit(false);
    };

    const backHandler = () => {
        // Logic to navigate back to the previous page or dashboard
        window.history.back();
    }





    const handleSubmit = () => {
        // data.norepetation = "0";
        // data.repeatedyear = "0";
        const answersArray: OriginalAnswer[] = Object.values(userAnswers);

        

        const answerCount = answersArray.filter((userRes: any) => {
            const original: any = qus.find((q: any) => q.unique_id === userRes.qustionId);
            return original && original.answer === Number(userRes.userAnswer);
        }).length;

        const payload = {
            user_id: userId,
            test_id: test_id,
            score: answerCount,
            total_questions: qus.length,
            answers: answersArray,
        }

        setCorrectCount(answerCount);

        // If test_id exists, call the updateDailyAssignments API
        if (test_id) {
            fetch(`${API_BASE_URL}/admin/updateDailyAssignments`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
                .then((response) => response.json())
                .then((data: any) => {
                    if (data.status > 0) {
                        setSubmited(true);
                    } else {
                        console.error("Error updating daily assignments:", data.message);
                    }
                })
                .catch((error) => {
                    console.error("Error updating daily assignments:", error);
                });
        } else {
            // Fallback behavior if no test_id (direct navigation)
            setSubmited(true);
        }
    }




    const totalPages = Math.ceil(qus.length / 1);

    const hangleNextPage = () => {

        setProgressValue(Math.round((Object.entries(userAnswers).length / totalPages) * 100));
        // updateProgressValue();
        // Logic to fetch questions for the next page based on currentIndex
        // For example, you might want to fetch questions for the next page from the server here
        // After fetching, update the qus state with the new questions and increment the currentIndex
        // setcurrentIndex(prevPage => Math.max(prevPage + 1, 1));
        setcurrentIndex(prevPage => {
            // Only increment if we haven't reached the last page
            if (prevPage < totalPages) {
                return prevPage + 1;
            }
            return prevPage;
        });
    }

    const hanglePrevPage = () => {

        // updateProgressValue();
        // Logic to fetch questions for the previous page based on currentIndex
        // For example, you might want to fetch questions for the previous page from the server here
        // After fetching, update the qus state with the new questions and decrement the currentIndex
        // setcurrentIndex(prevPage => Math.max(prevPage - 1, 1)); // Ensure currentIndex doesn't go below 1
        setcurrentIndex(prevPage => {
            // Only decrement if we are above page 1
            if (prevPage > 1) {
                return prevPage - 1;
            }
            return prevPage;
        });
    }

    const handleOptionChange = (questionId: string, selectedOption: string) => {
        const selectedQuestion = {
            qustionId: questionId,
            userAnswer: selectedOption,
        };

        setUserAnswers({ ...userAnswers, [currentIndex]: selectedQuestion });
    }
    return (
        <>
            {

                !submited && <div className="flex w-full flex-col bg-accent justify-start p-10">
                    <div className="flex justify-between">
                        <h2 className="text-3xl font-bold">testify.guru</h2>
                        {/* <span className="text-xl">Guest</span> */}
                        <div className="avatar avatar-placeholder">
                            <div className="bg-neutral text-neutral-content w-16 rounded-full flex items-center justify-center pt-3">
                                <span className="text-3xl">G</span>
                            </div>
                        </div>


                    </div>
                    <div className="card w-auto bg-base-100 shadow-md m-0 top-5">
                        <div className="card-body">

                            {/* <h2 className="card-title">Features</h2> */}
                            <div className="flex justify-between">
                                {/* <h2 className="text-3xl font-bold">Timer</h2> */}
                                {/* For TSX uncomment the commented types below */}
                                {/* For TSX uncomment the commented types below */}
                                <div className="tooltip" data-tip="This feature will be enabled soon">
                                    <span className="countdown font-mono text-2xl opacity-40 cursor-not-allowed">
                                        <span style={{ "--value": 10 } as React.CSSProperties} aria-live="polite" aria-label={"counter"}>10</span>:
                                        <span style={{ "--value": 24 } as React.CSSProperties} aria-live="polite" aria-label={"counter"}>24</span>:
                                        <span style={{ "--value": 59, "--digits": 2 } as React.CSSProperties} aria-live="polite" aria-label={"counter"}>59</span>
                                    </span>
                                </div>
                                {/* <span className="text-xl">Submit</span> */}
                                <button className="btn btn-accent" disabled={!enableSubmit} onClick={handleSubmit}>Submit</button>

                            </div>
                        </div>
                        <div className="card w-auto bg-base-100">
                            <div className="card-body">

                                <div className="flex flex-col-reverse md:flex-row">
                                    {
                                        isLoading &&
                                        <div className="basic-1 flex flex-row">
                                            {<span className="loading loading-spinner loading-xl p-10 m-10"></span>}
                                        </div>
                                    }

                                    {
                                        !isLoading && <>
                                            <div className="basis-2/3 flex flex-col">
                                                <div className="flex items-start">
                                                    <div className="flex flex-col gap-1 items-start text-left">
                                                        <h2 className="card-title block text-xl font-bold pt-10 md:pt-0 ">Question {currentIndex} of {totalPages}</h2>
                                                        <div className="">{qus[currentIndex - 1] && qus[currentIndex - 1]?.question}</div>
                                                    </div>
                                                </div>
                                                <div className="text-left">
                                                    <div className="flex flex-col md:flex-row justify-start">
                                                        <div className="w-full md:w-auto grow">
                                                            <div className="w-full md:w-auto">
                                                                <fieldset className="fieldset rounded-box px-4">
                                                                    <label className="label p-4 justify-start gap-4">
                                                                        <input type="radio" className="radio radio-primary" name={`radio-${currentIndex}`} onChange={(e) => handleOptionChange(qus[currentIndex - 1].unique_id,
                                                                            e.target.value)} value="1" checked={userAnswers[currentIndex]?.userAnswer === "1"} />
                                                                        {qus[currentIndex - 1] && qus[currentIndex - 1]?.optionA}
                                                                    </label>
                                                                </fieldset>

                                                            </div>

                                                        </div>
                                                        <div className="w-auto md:w-auto grow">
                                                            <div className="w-auto md:w-auto">
                                                                <fieldset className="fieldset rounded-box px-4">
                                                                    <label className="label p-4 justify-start gap-4">
                                                                        <input type="radio" className="radio radio-primary" name={`radio-${currentIndex}`} onChange={(e) => handleOptionChange(qus[currentIndex - 1].unique_id,
                                                                            e.target.value)} value="2" checked={userAnswers[currentIndex]?.userAnswer === "2"} />
                                                                        {qus[currentIndex - 1] && qus[currentIndex - 1]?.optionB}
                                                                    </label>
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="text-left">

                                                        <div className="flex flex-col md:flex-row justify-start">
                                                            <div className="w-full md:w-auto grow">
                                                                <div className="w-full md:w-auto">
                                                                    <fieldset className="fieldset rounded-box px-4">
                                                                        <label className="label p-4 justify-start gap-4">
                                                                            <input type="radio" className="radio radio-primary" name={`radio-${currentIndex}`} onChange={(e) => handleOptionChange(qus[currentIndex - 1].unique_id,
                                                                                e.target.value)} value="3" checked={userAnswers[currentIndex]?.userAnswer === "3"} />
                                                                            {qus[currentIndex - 1] && qus[currentIndex - 1]?.optionC}
                                                                        </label>
                                                                    </fieldset>

                                                                </div>

                                                            </div>
                                                            <div className="w-full md:w-auto grow">
                                                                <div className="w-full md:w-auto">
                                                                    <fieldset className="fieldset rounded-box px-4">
                                                                        <label className="label p-4 justify-start gap-4">
                                                                            <input type="radio" className="radio radio-primary" name={`radio-${currentIndex}`} onChange={(e) => handleOptionChange(qus[currentIndex - 1].unique_id,
                                                                                e.target.value)} value="4" checked={userAnswers[currentIndex]?.userAnswer === "4"} />
                                                                            {qus[currentIndex - 1] && qus[currentIndex - 1]?.optionD}
                                                                        </label>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div className="basis-1/3 items-center flex items-center justify-center">
                                                <div
                                                    className="radial-progress text-accent size-27"
                                                    style={{ "--value": progressValue, "--thickness": "4px" } as React.CSSProperties} aria-valuenow={progressValue} role="progressbar">
                                                    {progressValue}%
                                                </div>
                                            </div>
                                        </>
                                    }


                                </div>




                            </div>


                        </div>
                    </div>

                    <div className="flex justify-center p-5 m-5">
                        <div className="join">
                            {/* Always visible: Previous Button */}
                            <button className={`join-item btn btn-outline btn-sm md:btn-md ${currentIndex === 1 ? 'btn-disabled' : ''}`} onClick={hanglePrevPage}>« Prev</button>

                            {/* Visible ONLY on Desktop (md: screens and up) */}
                            <div className="hidden md:flex">
                                <>
                                    {[...Array(qus.length)].map((page, index) => (
                                        <button key={index} className={`join-item btn btn-sm md:btn-md ${index + 1 === 1 ? 'btn-active' : ''}`}>
                                            {index + 1}
                                        </button>
                                    ))}
                                </>
                            </div>

                            {/* Always visible: Next Button */}
                            <button className={`join-item btn btn-outline btn-sm md:btn-md ${currentIndex === totalPages ? 'btn-disabled' : ''}`} onClick={hangleNextPage}>Next »</button>
                        </div>
                    </div>

                </div>
            }



            {/* <form onSubmit={onSubmit}> */}
            <div>
                {
                    submited && test_id == null &&
                    <>
                        <button className="btn btn-accent" onClick={retestHandler}>Re-test</button>
                        <PerformanceSummary
                            correctPercent={correctCount / qus.length * 100} wrongPercent={100 - (correctCount / qus.length * 100)} />
                    </>

                }

                {
                    submited && test_id != null &&
                    <>
                        <button className="btn btn-accent" onClick={backHandler}>Back</button>
                        <PerformanceSummary
                            correctPercent={correctCount / qus.length * 100} wrongPercent={100 - (correctCount / qus.length * 100)} />
                    </>
                }

                {
                    submited && qus.length &&
                    qus.map((q: any, index: any) => (
                        <QuizCard
                            key={index}
                            qusNumber={index + 1}
                            question={q.question}
                            options={[q.optionA, q.optionB, q.optionC, q.optionD]}
                            correctAnswer={q.answer === 1 ? q.optionA : q.answer === 2 ? q.optionB : q.answer === 3 ? q.optionC : q.optionD}
                            userAnswer={userAnswers[index + 1]?.userAnswer === "1" ? q.optionA : userAnswers[index + 1]?.userAnswer === "2" ? q.optionB : userAnswers[index + 1]?.userAnswer === "3" ? q.optionC : userAnswers[index + 1]?.userAnswer === "4" ? q.optionD : null}
                        />

                    ))
                }


            </div>

        </>
    );
};

export default GenQus;
